import { getRequest } from '../services/requestHandler';
import { GripSize } from '../models';

export const getGripSizes = async () => {
  const url = 'grip/getGripSizes?activeOnly=true';
  const response = await getRequest<GripSize>('GetGripSizes', url);
  return response;
};
